module.exports = __webpack_public_path__ + "static/media/badge_challenge_2.601103fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_challenge_2.png
// module id = 497
// module chunks = 0